import React from 'react';
import { LoadingWraper } from './styles';

export const LoadingMain = () => {
  return <LoadingWraper></LoadingWraper>;
};
